import { inject, type Ref } from 'vue'
import type { UserData } from '@/interfaces/interfaces'

export function useAuth() {
  const userData = inject('userData') as Ref<UserData | null>

  return {
    userData
  }
}
